import 'css-chunk:src/event-selection/EventItem.module.scss';export default {
  "wrapper": "_wrapper_42kt1_1",
  "content": "_content_42kt1_9",
  "infoButton": "_infoButton_42kt1_27",
  "title": "_title_42kt1_40",
  "showInCalendar": "_showInCalendar_42kt1_46",
  "checkbox": "_checkbox_42kt1_50"
};